// Admin Layout Component
import React from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        .nln-admin, .nln-admin * {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
          box-sizing: border-box;
        }
        .nln-admin ::-webkit-scrollbar { width: 4px; height: 4px; }
        .nln-admin ::-webkit-scrollbar-track { background: transparent; }
        .nln-admin ::-webkit-scrollbar-thumb { background: #CBD5E1; border-radius: 10px; }
        .nln-admin ::-webkit-scrollbar-thumb:hover { background: #94A3B8; }

        .nln-nav-link {
          display: flex; align-items: center; gap: 10px;
          padding: 9px 14px; margin: 1px 10px;
          border-radius: 10px; text-decoration: none;
          transition: all 0.18s ease;
          background: transparent;
        }
        .nln-nav-link:hover { background: #F1F5F9 !important; }
        .nln-nav-link.nln-active { background: rgba(3,168,74,0.09) !important; }

        .nln-card {
          background: #FFFFFF;
          border-radius: 16px;
          border: 1px solid rgba(12,34,57,0.05);
          box-shadow: 0 2px 16px rgba(12,34,57,0.055);
          transition: box-shadow 0.2s ease;
        }
        .nln-card:hover { box-shadow: 0 4px 28px rgba(12,34,57,0.1); }

        .nln-stat-chip {
          display: inline-flex; align-items: center; gap: 5px;
          padding: 4px 10px; border-radius: 20px;
          font-size: 11px; font-weight: 600;
        }
        .nln-stat-chip.up   { background: rgba(3,168,74,0.1);  color: #03A84A; }
        .nln-stat-chip.down { background: rgba(239,68,68,0.1); color: #EF4444; }
        .nln-stat-chip.neu  { background: rgba(100,116,139,0.1); color: #64748B; }

        .nln-view-btn {
          background: none; border: none; cursor: pointer;
          color: #1557B0; font-size: 12px; font-weight: 600;
          padding: 0; transition: opacity 0.15s ease;
          font-family: 'Inter', sans-serif !important;
        }
        .nln-view-btn:hover { opacity: 0.7; }

        .nln-quick-btn {
          background: none; border: none; cursor: pointer;
          border-radius: 12px; padding: 14px 10px;
          transition: all 0.2s ease; display: flex;
          flex-direction: column; align-items: center; gap: 8px;
          font-family: 'Inter', sans-serif !important;
        }
        .nln-quick-btn:hover { transform: translateY(-3px); }

        .nln-activity-row { transition: background 0.15s ease; border-radius: 8px; }
        .nln-activity-row:hover { background: #F8FAFC !important; }

        @keyframes nlnFadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .nln-fade-up { animation: nlnFadeUp 0.38s ease forwards; }

        @keyframes nlnSpin { to { transform: rotate(360deg); } }
        .nln-spinner {
          animation: nlnSpin 0.75s linear infinite;
          border-radius: 50%;
        }
      `}</style>

      <div className="nln-admin" style={{
        display: 'flex',
        minHeight: '100vh',
        background: '#EEF2F7',
      }}>
        <Sidebar />
        <div style={{
          marginLeft: '250px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}>
          <TopBar />
          <main style={{
            flex: 1,
            padding: '28px 30px',
            overflowY: 'auto',
          }}>
            {children}
          </main>
        </div>
      </div>
    </>
  );
};

export default AdminLayout;
